module.exports = __webpack_public_path__ + "img/red_exclamation.55050050.svg";